
import { $devWarn } from "@/utils/devLog";
import { hash } from "@/utils/hash";
import { EMAIL_CAPTURE, LEAD_FORM_SUBMIT } from "@/eventIds";

const eventIdMap = {

}

export default {
  fireEvent(id, data) {
    sendGTMEvent(eventIdMap[id] ?? id, data);
  },
  [EMAIL_CAPTURE](id, email) {
    setUserVariables({ 'sha256_email_address': hash(email.toLowerCase()) });
  },
  [LEAD_FORM_SUBMIT](id, data) {
    const userData = {};

    if(data.sha256_email_address) {
      userData.sha256_email_address = data.sha256_email_address;
    }
    
    if(data.sha256_phone_number) {
      userData.sha256_phone_number = data.sha256_phone_number;
    }

    if (data.sha256_first_name || data.sha256_last_name) {
      userData.address = userData.address || {};

      if (data.sha256_first_name) {
        userData.address.sha256_first_name = data.sha256_first_name;
      }

      if (data.sha256_last_name) {
        userData.address.sha256_last_name = data.sha256_last_name;
      }
    }

    if (Object.keys(userData).length > 0) {
      setUserVariables(userData);
    }
    sendGTMEvent(eventIdMap[id] ?? id, data);
  }
}

function sendGTMEvent(action, options) {
  if (typeof window.dataLayer === "undefined") {
    $devWarn("window.dataLayer is undefined");
  } else {
    window.dataLayer.push({ 'event': action, 'eventModel': {...options} });
  }
}

function setUserVariables(data) {
  window.dataLayer.push({ 'user_data': {...data} });
}